import * as React from "react";
import { useTranslation } from "react-i18next";
import { LinkContainer } from "components/common";
import Routes from "routing/Routes";
import { Button } from "components/bootstrap";
const EditLinkButton = ({ authenticationBackendId, stepKey }) => {
  const { t } = useTranslation("authentication");
  return /* @__PURE__ */ React.createElement(LinkContainer, { to: Routes.SYSTEM.AUTHENTICATION.BACKENDS.edit(authenticationBackendId, stepKey) }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", bsSize: "small" }, t("config_details.edit")));
};
export default EditLinkButton;
